// extracted by mini-css-extract-plugin
export default {"container":"yHQkArqK","backButtonContainer":"wn48HZeM","backButton":"mZBiaAlb"};